import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_booking/flightsmanyquery/results')({
  validateSearch: z.object({ q: z.string().optional() }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/vols-multi/resultats', search, replace: true })
  },
})
